import Vue from 'vue';
import SearchResultRow from './SearchResultRow.vue';
export default Vue.extend({
    name: 'SearchResultsDropdown',
    components: {
        SearchResultRow
    },
    props: {
        results: {
            type: Array,
            required: true
        },
        totalMatches: {
            type: Number,
            default: 0
        },
        sessionResultsCount: {
            type: Number,
            default: 0
        },
        selectedIndex: {
            type: Number,
            default: -1
        },
        showEmpty: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        handleResultClick(result) {
            this.$emit('result-clicked', result);
        },
        handleProjectClick(payload) {
            this.$emit('project-clicked', payload);
        },
        handleCategoryClick(payload) {
            this.$emit('category-clicked', payload);
        },
        getResultKey(result, index) {
            if (result.type === 'session' && result.id) {
                return `session-${result.id}`;
            }
            if (result.type === 'category') {
                return `category-${result.project}-${result.category}`;
            }
            if (result.type === 'project') {
                return `project-${result.project}`;
            }
            return `result-${index}`;
        }
    }
});
